<div class = "ui-skeleton-container" [style.gap]="gap" [ngClass] = "{'ui-skeleton-container-column': viewMode === 'vertical', 'ui-skeleton-container-center': align === 'center'}">
    @if (type === 'header-with-icon') {
        @for (empty of emptyElements; track empty) {
            <div class = "ui-skeleton-header-with-icon">
                <div class = "ui-skeleton-header-icon" [skeletonLoaderPipe] = "'circle'" [style.width] = "((!width[0]) ? '5rem' : (width[0]))" [style.height] = "((heigth) || (!width[0]) ? '5rem' : (width[0]))">
                </div>
                <div class = "ui-skeleton-header" style = "gap: 0.5rem">
                    <div class = "ui-skeleton-rect" [skeletonLoaderPipe] = "'rect'" style = "padding: 0 0.9rem" [style.height] = "(heigth)" [style.width] = "((!width[1]) ? '5rem' : (width[1]))">
                        Carregando
                    </div>
                    <div class = "ui-skeleton-rect" [skeletonLoaderPipe] = "'rect'" style = "padding: 0 1.8rem" [style.height] = "(heigth)" [style.width] = "((!width[2]) ? '5rem' : (width[2]))">
                        Carregando
                    </div>
                </div>
            </div>
        }
    } @else if (type === 'line') {
        @for (empty of emptyElements; track empty; let i = $index) {
            <div class = "ui-skeleton-rect" [skeletonLoaderPipe] = "'rect'" [style.width] = "((!width[i]) ? '5rem' : (width[i]))" [style.height] = "(heigth)">
                Carregando
            </div>
        }
    } @else if (type === 'list') {
        @for (empty of emptyElements; track empty) {
            <div class = "ui-skeleton-line" [style.height] = "(heigth)">
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </div>
        }
    } @else if (type === 'circle') {
        <div class = "ui-skeleton-header-icon" [skeletonLoaderPipe] = "'circle'" [style.width] = "((!width[0]) ? '5rem' : (width[0]))" [style.height] = "((heigth) || (!width[0]) ? '5rem' : (width[0]))">
        </div>
    }
</div>
